
<div class="container">
  <h3>Roles and Permissions</h3>
  <div class="row mt-3">
    <div class="col">
      <div class="card">
        <div class="card-body">
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="input-group">
                <input class="form-control" type="text" placeholder="Search roles..." [(ngModel)]="searchTerm" (keyup)="search()">
              </div>
            </div>
            <div class="col-md-6 text-right">
              <div class="form-inline float-right"><span class="mr-2">{{ (currentPage - 1) * pageSize + 1 }} - {{ Math.min(currentPage * pageSize, filteredRoles.length) }} of {{ filteredRoles.length }}</span></div>
            </div>
          </div>
          <div class="table-responsive" style="max-height: 500px; overflow-y: auto;">
            <table class="table table-striped table-bordered">
              <thead style="background-color: #0096d6; color: white; position: sticky; top: 0; z-index: 1;">
                <tr>
                  <th>Role</th>
                  <th>Description</th>
                  <th>Permission</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of paginatedRoles">
                  <td>{{ item.role }}</td>
                  <td style="white-space: pre-line;">{{ item.description}}</td>
                  <td>{{ item.permission }}</td>
                  <td> 
                    <ul class="list-style-disc">
                      <li *ngFor="let action of item.actions" style="list-style-type: disc;">{{ action }}</li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row mt-3">
            <div class="col-md-12" style="overflow-x: auto;">
              <ul class="pagination justify-content-center">
                <li class="page-item" [class.disabled]="currentPage === 1"><a class="page-link" href="javascript:void(0)" (click)="setPage(currentPage - 1)">Previous</a></li>
                <li class="page-item" *ngFor="let page of pageNumbers" [class.active]="page === currentPage"><a class="page-link" href="javascript:void(0)" (click)="setPage(page)">{{ page }}</a></li>
                <li class="page-item" [class.disabled]="currentPage === totalPages"><a class="page-link" href="javascript:void(0)" (click)="setPage(currentPage + 1)">Next</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>